export const spotifyCardSx = { borderRadius: '12px' };
